module.exports = __webpack_public_path__ + "img/gift15.e9045b4d.png";